import { feedbackColorGreenPure, feedbackColorYellowPure, feedbackColorRedPure, feedbackColorOrangePure, feedbackColorPinkPure, feedbackColorPurplePure, feedbackColorBluePure, feedbackColorTurqPure } from '@deskfy/unify-design-tokens/jsvariables'

;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .directive('avatar', avatar)

  /* @ngInject */
  function avatar (UserService) {
    return {
      restrict: 'E',
      scope: {
        user: '<',
        width: '<',
        plus: '<'
      },
      templateUrl: '/core/directives/avatar/avatar-directive.html?$$REVISION$$',
      link: function ($scope, element, attributes) {
        const COLORS_PALETTE = [feedbackColorGreenPure, feedbackColorYellowPure, feedbackColorRedPure, feedbackColorOrangePure, feedbackColorPinkPure, feedbackColorPurplePure, feedbackColorBluePure, feedbackColorTurqPure]

        $scope.getImageProfile = UserService.getUserProfileImage.bind(UserService)

        $scope.getInitials = (name) => {
          let output = ''

          if (!name) {
            return output
          }

          let i = 0

          const str = name.split(' ')

          const len = str.length > 2 ? 2 : str.length

          for (i; i < len; i++) if (str[i] !== '') output += str[i][0]
          return output.toUpperCase()
        }

        $scope.getAutoColor = (name) => {
          if ($scope?.user?.userStatus === 'REMOVED') {
            return '#DEE3E3'
          }

          if (!name) {
            return '#01DBCE'
          }

          let i

          const lon = name.length

          let charIndex = 0

          for (i = 0; i < lon; i++) charIndex = name.charCodeAt(i)
          const colorIndex = charIndex % COLORS_PALETTE.length
          return COLORS_PALETTE[colorIndex]
        }
      }
    }
  }
})()
